const merge = require('lodash.merge');
const {get, post, patch, del} = require('./agent');

module.exports = (global_options) => {
  return {
    create: (data, local_options) => {
      const options = merge({}, global_options, local_options);
      return post('/users', data, options);
    },
    info: (local_options) => {
      const options = merge({}, global_options, local_options);
      return get('/userinfo', options);
    },
  }
}



// WEBPACK FOOTER //
// ../covert/users.js